import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useState, useEffect } from 'react';

export default function TheComp() {
    const { t } = useLang('dp3.page_v2');
    const [video, setVideo] = useState<[string, string]>(['', '']);
    const [enter, setEnter] = useState<boolean>(false);

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         if (window.innerWidth > 1024) {
    //             setVideo([
    //                 'https://websiteoss.ecoflow.com/upload/video/1742457994870/CutCosts.mp4',
    //                 'https://websiteoss.ecoflow.com/upload/image/1735636705750/CutCosts-poster.jpg',
    //             ]);
    //         } else {
    //             setVideo([
    //                 'https://websiteoss.ecoflow.com/upload/video/1742457970027/CutCosts-M.mp4',
    //                 'https://websiteoss.ecoflow.com/upload/image/1735637623634/CutCosts-poster-h5.jpg',
    //             ]);
    //         }
    //     }
    // }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const box: HTMLDivElement | null = document.querySelector('#dp3-K4 .box');
            if (box) {
                const winH = window.innerHeight;
                const secne1 = AniContainer.create({
                    triggerElement: box,
                    triggerHook: 1,
                    offset: box.offsetHeight / 2,
                    duration: winH + box.offsetHeight / 2,
                    onEnter: () => setEnter(true),
                    onLeave: () => setEnter(false),
                });

                return () => {
                    secne1.destroy();
                };
            }
        }
    }, [video]);

    // useEffect(() => {
    //     if (enter && typeof window !== 'undefined') {
    //         const video: HTMLVideoElement | null = document.querySelector('#dp3-K4 .box-video');
    //         if (video) {
    //             video.currentTime = 0;
    //             video.play();
    //         }
    //     }
    // }, [enter]);

    return (
        <section className={styles.section} id="dp3-K4">
            <div className={`box${enter ? ' enter' : ''}`}>
                <EcoImg
                    className="box-video"
                    pc="https://websiteoss.ecoflow.com/upload/image/1748919884754/pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1748919884754/pc.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1748919884379/h5.jpg"
                />
                {/* {video[0] && video[1] && <video className="box-video" src={video[0]} poster={video[1]} muted playsInline preload="auto" />} */}
                <div className="box-info">
                    <p className="box-info-label">{t('K4_label')}</p>
                    <p className="box-info-title">{t('K4_title')}</p>
                    <p className="box-info-desc">{t('K4_desc')}</p>
                </div>
                <div className="box-memo">
                    <p className="box-memo-title">{t('K4_memo_title')}</p>
                    <p className="box-memo-desc">{t('K4_memo_desc')}</p>
                </div>
            </div>
        </section>
    );
}
